import React, { useState, useEffect } from 'react';
import API from '../api/api';

const ROLES = [
  { id: 'admin', label: 'مدير النظام' },
  { id: 'manager', label: 'مدير شراكة' },
  { id: 'operator', label: 'مسؤول تشغيل' },
  { id: 'partner', label: 'شريك (تقارير فقط)' },
];
const getCurrentUser = () => JSON.parse(localStorage.getItem('user')||'null');
const isManager = () => { const u=getCurrentUser(); return u && u.role==='manager'; };

const PERMISSIONS = [
  { group: 'التبويبات الرئيسية', items: [
    { id: 'schedule', label: 'جدول التشغيل' },
    { id: 'partners', label: 'الشركاء (إضافة/تعديل)' },
    { id: 'bills', label: 'فواتير الكهرباء' },
    { id: 'expenses', label: 'المصروفات' },
    { id: 'revenues', label: 'الإيرادات' },
    { id: 'general_revenue', label: 'الإيراد العام' },
    { id: 'summary', label: 'ملخص الحسابات' },
    { id: 'reports', label: 'التقارير' },
    { id: 'whatsapp', label: 'واتساب' },
    { id: 'whatsapp_api', label: 'إرسال واتساب (API)' },
    { id: 'whatsapp_manual', label: 'إرسال واتساب (يدوي)' },
  ]},
  { group: 'لوحة التحكم', items: [
    { id: 'cp_info', label: 'معلومات البئر' },
    { id: 'cp_partners', label: 'الشركاء' },
    { id: 'cp_cycles', label: 'الدورات' },
    { id: 'cp_sessions', label: 'جلسات التشغيل' },
    { id: 'cp_fees', label: 'رسوم العداد والعامل' },
    { id: 'cp_whatsapp', label: 'إعدادات الواتساب' },
    { id: 'cp_lists', label: 'قوائم المصروفات' },
    { id: 'cp_slots', label: 'الخانات والإصدارات' },
    { id: 'cp_security', label: 'الأمان' },
    { id: 'cp_backup', label: 'النسخة الاحتياطية' },
    { id: 'cp_users', label: 'إدارة المستخدمين' },

  ]},
];

export default function UserManagement({ partnerships }) {
  const [users, setUsers] = useState([]);
  const [partners, setPartners] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ username:'', password:'', name:'', role:'operator', partnership_id:'', permissions:[] });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    load();
    // نجلب قائمة الشركاء
    const pid = partnerships && partnerships.length > 0 ? partnerships[0].id : null;
    if(pid) API.get(`/partners/?partnership=${pid}`).then(r => setPartners(r.data)).catch(()=>{});
  }, []);

  const getPartnershipId = () => {
    const u = JSON.parse(localStorage.getItem('user')||'null');
    if(u && u.role === 'manager') return u.partnership_id;
    // الأدمن يفلتر حسب الشراكة الحالية إذا كانت ممررة
    return partnerships && partnerships.length === 1 ? partnerships[0].id : null;
  };
  const load = () => {
    const pid = getPartnershipId();
    const url = pid ? `/users/?partnership_id=${pid}` : '/users/';
    API.get(url).then(r => {
      setUsers(r.data);
    });
  };

  const togglePerm = (id) => {
    const perms = form.permissions.includes(id)
      ? form.permissions.filter(p=>p!==id)
      : [...form.permissions, id];
    setForm({...form, permissions: perms});
  };

  const selectAll = () => {
    const all = PERMISSIONS.flatMap(g=>g.items.map(i=>i.id));
    setForm({...form, permissions: all});
  };

  const clearAll = () => setForm({...form, permissions: []});

  const validatePassword = (pwd) => {
    if (pwd.length < 10) return 'كلمة المرور يجب أن تكون 10 خانات على الأقل';
    if (!/[A-Z]/.test(pwd)) return 'يجب أن تحتوي على حرف كبير';
    if (!/[a-z]/.test(pwd)) return 'يجب أن تحتوي على حرف صغير';
    if (!/[0-9]/.test(pwd)) return 'يجب أن تحتوي على رقم';
    if (!/[!@#$%^&*()_+\-=\[\]{};':\|,.<>\/?]/.test(pwd)) return 'يجب أن تحتوي على رمز خاص (!@#$...)';
    return null;
  };

  const validateUsername = (uname) => {
    if (!/^\d{10}$/.test(uname)) return 'اسم المستخدم يجب أن يكون 10 أرقام (سجل مدني أو رقم إقامة)';
    return null;
  };

  const save = async () => {
    try {
      // التحقق من اسم المستخدم
      if(!editUser) {
        const unameErr = validateUsername(form.username);
        if(unameErr) { setMsg(unameErr); return; }
      }
      // التحقق من كلمة المرور
      if(!editUser || form.password) {
        const pwdErr = validatePassword(form.password);
        if(pwdErr) { setMsg(pwdErr); return; }
      }
      // مدير الشراكة يضيف مسؤول تشغيل واحد فقط
      if(!editUser && isManager()) {
        const operatorCount = users.filter(u => u.role === 'operator').length;
        if(operatorCount >= 1) {
          setMsg('لا يمكن إضافة أكثر من مسؤول تشغيل واحد');
          return;
        }
      }
      if (editUser) {
        await API.put(`/users/${editUser.id}/`, form);
      } else {
        await API.post('/users/', form);
      }
      setMsg('تم الحفظ ✅');
      setShowForm(false); setEditUser(null);
      const cu=getCurrentUser(); setForm({ username:'', password:'', name:'', role:'operator', partnership_id: isManager()?cu.partnership_id:'', permissions:[] });
      load();
    } catch(e) {
      setMsg(e.response?.data?.error || 'خطأ');
    }
  };

  const del = async (u) => {
    if (!window.confirm(`حذف ${u.username}؟`)) return;
    await API.delete(`/users/${u.id}/`);
    load();
  };
  const toggleActive = async (u) => {
    const action = u.is_active ? 'تعطيل' : 'تفعيل';
    if (!window.confirm(`هل تريد ${action} المستخدم ${u.username}؟`)) return;
    await API.put(`/users/${u.id}/`, { action: 'toggle_active' });
    load();
  };

  const startEdit = (u) => {
    setEditUser(u);
    setForm({ username: u.username, password:'', name: u.name, role: u.role, partnership_id: u.partnership_id||'', permissions: u.permissions||[], email: u.email||'', phone: u.phone||'' });
    setShowForm(true);
  };

  return (
    <div style={{direction:'rtl'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'15px'}}>
        <h3 style={{margin:0,color:'#1e3a5f'}}>👥 إدارة المستخدمين</h3>
        <button onClick={()=>{setShowForm(true);setEditUser(null);setForm({username:'',password:'',name:'',role:'operator',partnership_id:'',permissions:[]})}}
          style={{padding:'8px 16px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontWeight:'bold'}}>
          + إضافة مستخدم
        </button>
      </div>

      {msg && <div style={{background:msg.includes('تم')?'#e8f5e9':'#fff3cd',color:msg.includes('تم')?'#1a7a3a':'#856404',padding:'8px',borderRadius:'6px',marginBottom:'10px',border:msg.includes('تم')?'1px solid #c3e6cb':'1px solid #ffc107'}}>{msg}</div>}

      {showForm && (
        <div style={{background:'#f8f9fa',border:'1px solid #ddd',borderRadius:'8px',padding:'15px',marginBottom:'15px'}}>
          <h4 style={{margin:'0 0 12px',color:'#1e3a5f'}}>{editUser ? 'تعديل مستخدم' : 'إضافة مستخدم جديد'}</h4>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'10px',marginBottom:'12px'}}>
            <div>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>اسم المستخدم</label>
              <input value={form.username} onChange={e=>setForm({...form,username:e.target.value})} disabled={!!editUser}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>كلمة المرور {editUser&&'(فارغة=بدون تغيير)'}</label>
              <input type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>الاسم الكامل</label>
              <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>البريد الإلكتروني</label>
              <input value={form.email||''} onChange={e=>setForm({...form,email:e.target.value})}
                placeholder="example@email.com"
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>الدور</label>
              <select value={form.role} onChange={e=>setForm({...form,role:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}>
                {ROLES.filter(r=>isManager()?r.id==='operator':true).map(r=><option key={r.id} value={r.id}>{r.label}</option>)}
              </select>
            </div>
            {!isManager() && <div>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>الشراكة</label>
              <select value={form.partnership_id} onChange={e=>setForm({...form,partnership_id:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}>
                {form.role !== 'partner' && <option value="">جميع الشراكات (أدمن)</option>}
                {partnerships?.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>}
          </div>

          {form.role !== 'admin' && form.role !== 'partner' && !isManager() && (
            <div style={{border:'1px solid #ddd',borderRadius:'8px',padding:'12px',marginBottom:'12px',background:'white'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'10px'}}>
                <span style={{fontWeight:'bold',fontSize:'13px',color:'#1e3a5f'}}>🔐 الصلاحيات</span>
                <div style={{display:'flex',gap:'8px'}}>
                  <button onClick={selectAll} style={{padding:'4px 10px',background:'#27ae60',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>تحديد الكل</button>
                  <button onClick={clearAll} style={{padding:'4px 10px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>مسح الكل</button>
                </div>
              </div>
              {PERMISSIONS.map(group=>(
                <div key={group.group} style={{marginBottom:'10px'}}>
                  <div style={{fontSize:'12px',fontWeight:'bold',color:'#666',marginBottom:'6px',borderBottom:'1px solid #eee',paddingBottom:'4px'}}>{group.group}</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                    {group.items.map(item=>(
                      <label key={item.id} style={{display:'flex',alignItems:'center',gap:'4px',cursor:'pointer',
                        padding:'4px 10px',borderRadius:'20px',fontSize:'12px',fontWeight:'bold',
                        background:form.permissions.includes(item.id)?'#1e3a5f':'#f0f0f0',
                        color:form.permissions.includes(item.id)?'white':'#333',
                        border:'1px solid '+(form.permissions.includes(item.id)?'#1e3a5f':'#ddd')}}>
                        <input type="checkbox" checked={form.permissions.includes(item.id)} onChange={()=>togglePerm(item.id)} style={{display:'none'}}/>
                        {item.label}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {form.role === 'partner' && (
            <div style={{marginBottom:'12px'}}>
              <label style={{fontSize:'12px',fontWeight:'bold',display:'block',marginBottom:'4px'}}>اسم الشريك</label>
              <select value={form.partner_name||''} onChange={e=>setForm({...form,partner_name:e.target.value,name:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',boxSizing:'border-box'}}>
                <option value="">-- اختر شريكاً --</option>
                {partners.filter(p=>{
                  const alreadyHasUser = users.some(u=>u.role==='partner'&&u.name===p.name&&(!editUser||u.id!==editUser.id));
                  return !alreadyHasUser;
                }).map(p=><option key={p.id} value={p.name}>{p.name}</option>)}
              </select>
            </div>
          )}
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={save} style={{padding:'8px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontWeight:'bold'}}>حفظ</button>
            <button onClick={()=>{setShowForm(false);setEditUser(null)}} style={{padding:'8px 20px',background:'#95a5a6',color:'white',border:'none',borderRadius:'6px',cursor:'pointer'}}>إلغاء</button>
          </div>
        </div>
      )}

      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead style={{position:'sticky',top:0,zIndex:10}}>
          <tr style={{background:'#1e3a5f',color:'white'}}>
            <th style={{padding:'10px',textAlign:'right',border:'1px solid #0d2137'}}>اسم المستخدم</th>
            <th style={{padding:'10px',textAlign:'right',border:'1px solid #0d2137'}}>الاسم الكامل</th>
            <th style={{padding:'10px',textAlign:'center',border:'1px solid #0d2137'}}>الدور</th>
            <th style={{padding:'10px',textAlign:'center',border:'1px solid #0d2137'}}>الشراكة</th>
            <th style={{padding:'10px',textAlign:'center',border:'1px solid #0d2137'}}>الصلاحيات</th>
            <th style={{padding:'10px',textAlign:'center',border:'1px solid #0d2137'}}>إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u=>(
            <tr key={u.id} style={{borderBottom:'1px solid #eee'}}>
              <td style={{padding:'10px',border:'1px solid #eee',fontWeight:'bold'}}>{u.username}</td>
              <td style={{padding:'10px',border:'1px solid #eee'}}>{u.name}</td>
              <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center'}}>
                <span style={{background:u.role==='admin'?'#1e3a5f':u.role==='manager'?'#27ae60':'#e67e22',color:'white',padding:'3px 10px',borderRadius:'12px',fontSize:'12px'}}>
                  {ROLES.find(r=>r.id===u.role)?.label||u.role}
                </span>
              </td>
              <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center',fontSize:'12px'}}>
                {u.partnership_id ? partnerships?.find(p=>p.id===u.partnership_id)?.name||u.partnership_id : 'جميع'}
              </td>
              <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center',fontSize:'11px',color:'#666'}}>
                {u.role==='admin' ? 'كل الصلاحيات' : (u.permissions||[]).length + ' صلاحية'}
              </td>
              <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center'}}>
                {u.role !== 'admin' && <>
                  <button onClick={()=>startEdit(u)} style={{padding:'4px 10px',background:'#3498db',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',marginLeft:'5px',fontSize:'12px'}}>تعديل</button>
                  <button onClick={()=>del(u)} style={{padding:'4px 10px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'12px'}}>حذف</button>
                  <button onClick={()=>toggleActive(u)} style={{padding:'4px 10px',background: u.is_active?'#7f8c8d':'#27ae60',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'12px',marginRight:'5px'}}>{u.is_active?'⛔ إيقاف':'✅ تفعيل'}</button>
                </>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
